import Footer from "./footer"
import Home from "./home/home";
import Impressum from "./impressum";
import ProjectPage from "./projects/ProjectPage";
import ResponsiveAppBar from "./navbar";
import { useRef, useEffect, useState } from "react";
import React from "react";
import { useLocation } from "react-router-dom";
import { data } from "../data.js";
 
  export default function Root() {
    const location = useLocation();
 
    const missionRef = useRef(null);
    const projectsRef = useRef(null);
    const teamRef = useRef(null);
    const contactRef = useRef(null);
 
    return (
      <div id="root">
        <ResponsiveAppBar
          missionRef={missionRef}
          projectsRef={projectsRef}
          teamRef={teamRef}
          contactRef={contactRef}
        />
      {location.pathname === "/" && (
          <Home
            missionRef={missionRef}
            projectsRef={projectsRef}
            teamRef={teamRef}
            data={data}
            contactRef={contactRef}
          />
       )}
       {location.pathname === "/Impressum" && <Impressum />}
       {/* jede project-<idx> URL */}
       {location.pathname.startsWith("/project/") && <ProjectPage />}
 
        <Footer />
      </div>
    );
  }
 